<template>
    <div :class ="!positionData.timeExit ? 'notification__zone_sub-wrapper' : positionData.resultDepo < 0 ? 'notification__zone_sub-wrapper notification__zone_sub-wrapper-red' : 'notification__zone_sub-wrapper notification__zone_sub-wrapper-green'">
        <div class="notification_order-title">
            <div class="notification_order-avatarWrap">
                <div class="notification_order-avatar">
                    <img src="../../assets/img/robot.jpg" />
                </div>
                <div class="notification_order-rorbotName">
                    Торговый робот
                </div>
            </div>
            <div class = "notification_order-title-status">{{positionData.timeExit ? 'Ордер закрыт' : 'Ордер открыт'}}</div>
            <div class="notification_order-wrap">
                <div class = "notification_order-title-pair">{{positionData.symbol}}</div>
                <div class = "notification_order-title-number">{{positionData.id}}</div>
            </div>
            <div class="notification_order-wrap">
                <div class = "notification_order-title-day">{{positionData.timeExit ? $datef(positionData.timeExit, 'd') : $datef(positionData.timeEnter, 'd')}}</div>
                <div class = "notification_order-title-time">{{positionData.timeExit ? $datef(positionData.timeExit, 't') : $datef(positionData.timeEnter, 't')}}</div>
            </div>
        </div>
        <div class="notification_order-main_data">
            <div class="notification_order-main_data-type_and_volume notification_order-block_big">
                <div class="notification_order-main_data-type_and_volume-data">
                    <div class="notification_order-sub-title">тип и объём</div>
                    <div class="notification_order-main_data-type_and_volume-data-type">
                        <svg v-if="positionData.side < 0" style="width:18px;height:18px" viewBox="0 0 24 24">
                            <path fill="#000000" d="M10,4H14V13L17.5,9.5L19.92,11.92L12,19.84L4.08,11.92L6.5,9.5L10,13V4Z" />
                        </svg>
                        <svg v-if="positionData.side > 0" style="width:18px;height:18px" viewBox="0 0 24 24">
                            <path fill="#000000" d="M14,20H10V11L6.5,14.5L4.08,12.08L12,4.16L19.92,12.08L17.5,14.5L14,11V20Z" />
                        </svg>
                        <div class="notification_order-sub-data">
                            {{
                            positionData.side < 0 ? 'SELL' : 'BUY'
                        }}</div>
                        <div class="notification_order-sub-data">{{$moneyf(positionData.volume)}}</div>
                    </div>
                </div>
            </div>
            <div class = "notification_order-main_data-price_open notification_order-block_midle">
                <div class="notification_order-sub-title">Цена откр.</div>
                <div class="notification_order-sub-data">{{positionData.priceEnter}}</div>
            </div>
            <div v-if="positionData.timeExit" class = "notification_order-main_data-price_open notification_order-block_midle">
                <div class="notification_order-sub-title">Цена закр.</div>
                <div class="notification_order-sub-data">{{positionData.curPrice}}</div>
            </div>
            <div class = "notification_order-main_data-price_sl notification_order-block_midle">
                <div class="notification_order-sub-title">S/L</div>
                <div class="notification_order-sub-data">{{positionData.sl}}</div>
            </div>
            <div class="notification_order-main_data-price_tp notification_order-block_midle">
                <div class="notification_order-sub-title">T/P</div>
                <div class="notification_order-sub-data">{{positionData.tp}}</div>
            </div>
        </div>
        <div v-if="positionData.timeExit" class="notification_order-main_data">
            <div class="notification_order-main_data-type_and_volume notification_order-block_big" style="min-width:176px;">
                <div class="notification_order-sub-title">время открытия</div>
                <div class="notification_order-sub-data">{{$datef(positionData.timeEnter)}}</div>
            </div>
            <div class="notification_order-main_data-type_and_volume">
                <div class="notification_order-sub-title">время закрытия</div>
                <div class="notification_order-sub-data">{{$datef(positionData.timeExit)}}</div>
            </div>
            <div class="notification_order-main_data-type_and_volume">
                <div class="notification_order-sub-title">результат</div>
                <div class="notification_order-sub-data-wrap">
                    <div class="notification_order-result">
                        $ {{positionData.resultDepo}}
                    </div>
                    <div class="notification_order-sub-data"
                        :class="(positionData.resultPoint < 0)? 'color-red' : 'color-green'"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props : {
        positionData: {default:{}}
    },
    computed: {
        ...mapGetters ({
        getCropStat: 'accountstat/getCroppedStatBySymbol',
        }),
        /*getPersentResult() {
            return (this.positionData.resultDepo/this.getCropStat().Summary.Equity*100).toFixed(3)
        }*/
    }
}
</script>
<style lang="less" scoped>
.notification__zone {
    &_sub-wrapper {
        background-color: rgb(255, 254, 204);
        //margin: 12px auto;
        width: 454px;
        border-bottom: 3px solid #374b62;
        &-red {
            background-color: @colors[red];
        }
        &-green {
            background-color: @colors[green];
        }
    }
}

.notification_order {
    &-title {
        display: flex;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.45;
        letter-spacing: 0.4px;
        padding: 12px 0 12px 12px;
        color: #3d536b;
        text-transform: uppercase;
        border-bottom: 1px solid #374b62;
        &-status {
            //margin-left: 12px;
        }
        &-pair {
            margin-left: 12px;
        }
        &-number {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-day {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-time {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
    }
    &-result {
        font-family: Arimo;
        font-size: 25px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.64;
        letter-spacing: 0.4px;
        color: #3d536b;
    }
    &-avatarWrap {
        display: flex;
        width: 160px;
    }
    &-avatar {
        width: 29px;
        height: 29px;
        border-radius: 50px;
        margin-right: 8px;
        overflow: hidden;
    }
    &-rorbotName {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #3d536b;
    }
    &-main_data {
        display: flex;
        padding: 12px 0;
        border-bottom: 1px solid #374b62;

        &-type_and_volume {
            width: 160px;
            &-data-type {
                display: flex;
                align-items: center;
            }
            &-img {
                height: 32px;
                font-size: 32px;
                padding-left: 12px;
                color:#000;
            }
            &-data {
                //margin-left: 8px;
            }
        }
    }
    &-sub-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        color: #7a8088;
        text-transform: uppercase;
    }
    &-sub-data {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.23;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        margin-right: 8px;
        &-wrap {
            display: flex;
        }
    }
    &-block_big {
        width: 176px;
        padding-left: 12px;
        box-sizing: border-box;
    }
    &-block_midle {
        margin-right: 10px;
        box-sizing: border-box;
    }
}
</style>
.notification__zone {
    &_sub-wrapper {
        background-color: rgb(255, 254, 204);
        border-radius: 4px;
        display: block;
        margin: 12px auto;
        width: 528px;
        box-shadow: 0 0 10px rgba(0,0,0,0.3);
    }
}

.notification_order {
    &-title {
        display: flex;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        text-transform: uppercase;
        border-bottom: 1px solid #374b62;
        &-status {
            margin-left: 12px;
        }
        &-pair {
            margin-left: 12px;
        }
        &-number {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-day {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-time {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
    }
    &-main_data {
        display: flex;
        padding: 12px 0;
        /*border-bottom: 1px solid #374b62;*/

        &-type_and_volume {
            display: flex;
            &-data-type {
                display: flex;
            }
            &-img {
                font-size:32px;
                color:#000;
            }
            &-data {
                margin-left: 8px;
            }
        }
    }
    &-sub-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        color: #7a8088;
        text-transform: uppercase;
    }
    &-sub-data {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.23;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        margin-right: 4px;
    }
    &-block_big {
        width: 176px;
        padding-left: 12px;
        box-sizing: border-box;
    }
    &-block_midle {
        width: 88px;
        padding-left: 12px;
        box-sizing: border-box;
    }
}
</style>
